import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=44110c6f&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
import style0 from "./loader.vue?vue&type=style&index=0&id=44110c6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44110c6f",
  null
  
)

export default component.exports